// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"8c7eeeee","310":"7ced0aab","473":"d3b35c0a","545":"ac7dc873","822":"aec255eb","970":"d2b5a716","977":"2b2aa8a2"}[chunkId] + ".chunk.css";
};